"use client";

import { useEffect } from "react";

// When a page is restored from the browser's back-forward cache (e.g. clicking Back,
// or in some browsers a plain refresh landing on a bfcache-eligible entry), the browser
// repaints a previously-rendered page from memory without ever asking the server "are
// you still logged in?" — so a page you saw while authenticated can still be shown after
// logging out. `pageshow`'s `persisted` flag is true exactly when a page came from
// bfcache; forcing a real reload in that case guarantees a fresh auth check every time.
export function BfcacheReload() {
  useEffect(() => {
    function handlePageShow(event: PageTransitionEvent) {
      if (event.persisted) {
        window.location.reload();
      }
    }
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  return null;
}
